import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "drawer-container"
};
import { ref, watch } from '../../../adapter-vue';
import Overlay from '../../common/Overlay/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    popDirection: {
      default: 'bottom'
    },
    isFullScreen: {
      type: Boolean,
      default: true
    },
    overlayColor: {},
    drawerStyle: {
      default: () => ({})
    }
  },
  emits: ["onOverlayClick"],
  setup(__props, _ref) {
    var _overlayDomInstanceRe;
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var drawerDomRef = ref();
    var overlayDomInstanceRef = ref();
    var isDrawerShow = ref(false);
    var styles = ref(props.drawerStyle[props.popDirection] || {});
    watch(() => props.visible, visible => {
      if (visible) {
        isDrawerShow.value = true;
      } else {
        setTimeout(() => {
          isDrawerShow.value = false;
        }, 150);
      }
    }, {
      immediate: true
    });
    function onOverlayClick(e) {
      emits('onOverlayClick', e);
    }
    __expose({
      drawerDomRef,
      overlayDomRef: (_overlayDomInstanceRe = overlayDomInstanceRef.value) === null || _overlayDomInstanceRe === void 0 ? void 0 : _overlayDomInstanceRe.overlayDomRef
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Overlay, {
        ref_key: "overlayDomInstanceRef",
        ref: overlayDomInstanceRef,
        visible: props.visible,
        maskColor: props.overlayColor,
        isFullScreen: props.isFullScreen,
        onOnOverlayClick: onOverlayClick
      }, {
        default: _withCtx(() => [_unref(isDrawerShow) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "drawerDomRef",
          ref: drawerDomRef,
          class: _normalizeClass({
            'drawer': true,
            'origin-bottom': props.popDirection === 'bottom',
            'origin-right': props.popDirection === 'right',
            'slide-bottom': _ctx.visible && props.popDirection === 'bottom',
            'slide-right': _ctx.visible && props.popDirection === 'right'
          }),
          style: _normalizeStyle({
            minHeight: _unref(styles).minHeight,
            maxHeight: _unref(styles).maxHeight,
            borderRadius: _unref(styles).borderRadius,
            boxShadow: _unref(styles).boxShadow,
            width: _unref(styles).width
          })
        }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])], 6)) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["visible", "maskColor", "isFullScreen"]);
    };
  }
});